import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const mutation = graphql`
  mutation SendReadyForSignatureReminderMutation($input: SendReadyForSignatureReminderToFollowersInput!) {
    sendReadyForSignatureReminderToFollowers(input: $input) {
      notificationCount
    }
  }
`;

export default (jobId, callback) => {
  commitMutation(getEnvironment(), {
    mutation,
    variables: { input: { jobId } },
    onCompleted: response => {
      callback(response.sendReadyForSignatureReminderToFollowers);
    },
    onError: err => console.error(err)
  });
};




